export const translation = {
    promotions: "Акції",
    collaborationFormTitle: "Подати заявку",
    collaborationFormName: "Ім'я*",
    collaborationFormLastName: "Прізвище*",
    collaborationFormEmail: "Email*",
    collaborationFormIco: "ІПН*",
    collaborationFormCountry: "Країна*",
    collaborationFormCity: "Місто*",
    collaborationFormPhone: "Номер телефону*",
    collaborationFormCertificate: "Номер сертифікату*",
    collaborationFormActivity: "Напрямок діяльності*",
    collaborationFormDic: "Робота з ПДВ*",
    collaborationFormDicNumber: "Номер ПДВ*",
    collaborationFormPassword: "Пароль",
    collaborationFormRegister: "реєстрація",
    collaborationFormNoResults: "Немає результатів",
    collaborationFormYes: "Так",
    collaborationFormNo: "Ні",
    collaborationFormSuccess: "Успішна реєстрація",
    collaborationPageWhyRenew: "Чому обирають SkinOn?",
    collaborationPageExclusive: "ЕКСКЛЮЗИВНІ МОЖЛИВОСТІ",
    collaborationPageExclusiveSubtitle: "ДЛЯ ПАРТНЕРІВ",
    collaborationPageRegistration: "ЗАРЕЄСТРУВАТИСЯ",
    inputCorrectPhoneNumber: "Будь ласка, введіть дійсний номер телефону",
};
